import $ from 'jquery';
import * as suggest from './suggest';
import debounce from 'lodash.debounce';
import { getQueryText } from './search';

export const init = ($target) => {
	const $headerSearch = $('.js-header-search'),
		$showSearchBtn = $('.js-show-search'),
		$queryTextInput = $headerSearch.find('input[name=queryText]');

	const DEBOUNCE_WAIT_MS = 500,
		ESCAPE_KEY_CODE = 27,
		QUERY_MIN_INPUT_LENGTH = 3;

	///////////////////////////////////////////////////////////////////////////////
	/// INITIALIZATION
	///////////////////////////////////////////////////////////////////////////////

	// hide on click outside
	$target.on('click', function () {
		hideSearchBox();
	});

	// prevent hiding on click outside
	$.merge($headerSearch, $showSearchBtn).on('click', function (event) {
		event.stopPropagation();
	});

	// show search box
	$showSearchBtn.on('click', function (event) {
		event.preventDefault();
		showSearchBox();
		$headerSearch.find('input[type=search][name=queryText]').trigger('focus');
	});

	// hide search box on ESCAPE_KEY
	$headerSearch.on('keydown', function (e) {
		if (e.keyCode === ESCAPE_KEY_CODE) {
			$(this).removeClass('is-active');
		}
	});

	// submit only if the input length is longer than the minimal length
	$headerSearch.on('submit', function (event) {
		if (getQueryText($queryTextInput).length < QUERY_MIN_INPUT_LENGTH) {
			event.preventDefault();
			showError();
		}
	});

	// update on segment change
	$headerSearch.find('input[type=radio][name=segment]').on('change', function (event) {
		$queryTextInput.trigger('input');
	});

	// hide error
	$queryTextInput.on('input', function () {
		if (getQueryText($queryTextInput).length >= QUERY_MIN_INPUT_LENGTH) {
			hideError();
		}
	});

	// on input
	$queryTextInput.on('input', debounce(onInput, DEBOUNCE_WAIT_MS));

	///////////////////////////////////////////////////////////////////////////////
	/// SEARCH EVENTS
	///////////////////////////////////////////////////////////////////////////////

	function onInput() {
		const suggestBaseUrl = $headerSearch.data('suggest-base-url'),
			params = getParams();

		let url = `${suggestBaseUrl}/${encodeURIComponent(params.queryText)}/${params.segment}`;

		suggest.onInput($queryTextInput, url);
	}

	///////////////////////////////////////////////////////////////////////////////
	/// UTILS
	///////////////////////////////////////////////////////////////////////////////

	function getParams() {
		return {
			segment: $headerSearch.find('input[name=segment][type=radio]:checked:first').val(),
			queryText: getQueryText($queryTextInput),
		};
	}

	function showSearchBox() {
		$headerSearch.addClass('is-active');
	}

	function hideSearchBox() {
		$headerSearch.removeClass('is-active');
	}

	function showError() {
		$queryTextInput.parent().addClass('has-error');
	}

	function hideError() {
		$queryTextInput.parent().removeClass('has-error');
	}
};
